import { useState, useEffect } from "react"
import $api from "@/api"
import { classModuleGenerator } from "@/utils"
import styles from "../index.module.less"

const classnames = classModuleGenerator(styles)

function Campus() {
  const [curIndex, setCurIndex] = useState(0)

  // useEffect(() => {

  // }, [])

  const citys = [
    {
      _id: 1,
      name: "北京",
      desc: "校区简介",
    },
    {
      _id: 2,
      name: "西安",
      desc: "校区简介",
    },
    {
      _id: 3,
      name: "广州",
      desc: "校区简介",
    },
    {
      _id: 4,
      name: "天津",
      desc: "校区简介",
    },
  ]
  return (
    <section className={classnames("campus-container")}>
      <h3 className="section__title">学大全日制全国校区</h3>
      <h3 className="section__stitle">
        安徽、南昌、无锡、兰州、银川、成都、重庆、贵阳、太原、河北、大连、青岛、哈尔滨、济南、长春、包头、沈阳、郑州、北京、福州、厦门、南宁、长沙......
      </h3>
      <div className="section__inner">
        <div className={classnames("campus-content")}>
          <ul className={classnames("citys")}>
            {citys.map((model, index) => {
              return (
                <li
                  key={model._id}
                  className={index === curIndex ? classnames("selected") : ""}
                  onMouseEnter={() => {
                    setCurIndex(index)
                  }}
                >
                  <h5>{model.name}</h5>
                  <p>{model.desc}</p>
                </li>
              )
            })}
          </ul>
          <div className={classnames("city-pic")}>
            {["bj", "xa", "gz", "tj"].map((str, index) => {
              return (
                <img
                  key={str}
                  className={index === curIndex ? classnames("selected") : ""}
                  src={require("@/assets/images/campus-" + str + ".png")}
                  alt=""
                />
              )
            })}
            {/* .selected
            <img src={require("@/assets/images/campus-bj.png")} alt="" />
            <img src={require("@/assets/images/campus-xa.png")} alt="" />
            <img src={require("@/assets/images/campus-gz.png")} alt="" />
            <img src={require("@/assets/images/campus-tj.png")} alt="" /> */}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Campus
